import * as yup from 'yup';
import { validationRules } from 'src/utils/validation/validationRules';

export const newNewsValidationSchema = yup.object().shape({
  title: validationRules.NEWS_TITLE,
  text: validationRules.NEWS_TEXT,
  link: validationRules.NEWS_LINK,
  expertise: validationRules.ARRAY_OF_NUMBERS_REQUIRED,
});
